module.exports = __webpack_public_path__ + "img/warning.48490a68.png";